import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import RosettaFormattedMessage from '../../common/rosetta_formatted_message';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../../utils/analytics';
import { Times } from '../../common/fa_icons';
import ResponsiveImg from '../../common/responsive_img';
import classNames from 'classnames';
import {isEqual} from 'lodash';

/*
 * The initial animation should be delayed 2000ms, regardless of hover state.
 * The full initial animation lasts 700ms.
 *
 */
export const HOVERING_STATE_DELAY_MS = 2700;
export const IMAGE_WIDTH = 340;
export const IMAGE_HEIGHT = 408;

export default class UpNext extends Component {
  state = {
    hidden: false,
    didShowInitialAnimation: false
  };

  componentDidMount() {
    this._timeout = window.setTimeout(
      () => this.setState({ didShowInitialAnimation: true }),
      HOVERING_STATE_DELAY_MS
    );
    sendAnalyticsEvent(
      'Slideshow',
      'Up Next',
      'Impression'
    );

    sendDataLayerEvent('View', {
      linkHeadline: this.props.title,
      pageModule: 'Slideshow',
      slideshowComponent: 'Up Next',
      slideNumber: this.props.slideNumber
    });
  }

  shouldComponentUpdate = (nextProps, nextState) =>
    this.props.isHovering !== nextProps.isHovering
    || !isEqual(this.state, nextState);

  componentWillUnmount = () =>
    window.clearTimeout(this._timeout);

  figureClassName = () => classNames(
    'up-next', {
      'hovering': this.state.didShowInitialAnimation && this.props.isHovering,
      'initial-animation': this.props.shouldShowInitialAnimation
    }
  );

  handleWrapperClick = ({ currentTarget: { href } }) => {
    sendAnalyticsEvent(
      'Slideshow',
      'Up Next',
      href
    );

    sendDataLayerEvent('Click', {
      pageModule: 'Slideshow',
      slideshowComponent: 'Up Next',
      slideNumber: this.props.slideNumber,
      itemName: this.props.title,
      linkTitle: this.props.title,
      linkType: 'article'
    });
  };

  handleCloseButtonClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ hidden: true });
  }

  handleCloseButtonKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
      this.setState({ hidden: true });
    }
  }

  render = () => (
    <Link
      to={this.props.url}
      onClick={this.handleWrapperClick}
      className={classNames('up-next-wrapper', this.state)}
    >
      <figure className={this.figureClassName()}>
        <div className="up-next-body">
          <ResponsiveImg src={this.props.opener_image}
            className="up-next-image"
            width={IMAGE_WIDTH}
            height={IMAGE_HEIGHT}
          />
          <div className="up-next-close-button"
            onClick={this.handleCloseButtonClick}
            onKeyDown={this.handleCloseButtonKeyDown}
            role="button"
            tabIndex={0}
            aria-label="Close"
          >
            <Times />
          </div>
          <div className="up-next-header">
            <RosettaFormattedMessage parentFilename={__filename}
              id="header"
              description="Header of Up Next module"
              defaultMessage="Up Next"
            />
          </div>
          <div className="up-next-title"
            dangerouslySetInnerHTML={{ __html: this.props.title }}
          />
        </div>
      </figure>
    </Link>
  );
}

UpNext.propTypes = {
  isHovering: PropTypes.bool.isRequired,
  opener_image: PropTypes.string.isRequired,
  shouldShowInitialAnimation: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  slideNumber: PropTypes.number.isRequired
};
